import { theme } from '../constants/defaults';
import { formatMoney } from '../utils/product';

export function renderNote(note) {
  if (!theme.settings.cartNotes) {
    return '';
  }

  return `
    <div class="input-group">
      <label for="CartSpecialInstructions">${theme.strings.cart_note}</label>
      <textarea name="note" id="CartSpecialInstructions">${note || ''}</textarea>
    </div>
  `;
}

export function renderFooter(state) {
  const { total_price: totalPrice, total_discount: totalDiscount } = state;

  return `
    <div class="ajaxcart__footer">
      <div class="grid grid--gutter-0">
        <div class="grid__item two-thirds">
          <p>${theme.strings.cart_subtotal}</p>
        </div>
        <div class="grid__item one-third text-right">
          <p class="ajaxcart__total-price">${formatMoney(totalPrice)}</p>
        </div>
        ${
          totalDiscount
            ? `
              <p class="ajaxcart__savings text-center">
                <em>${theme.strings.cart_savings.replace(
                  '[savings]',
                  formatMoney(totalDiscount),
                )}</em>
              </p>
            `
            : ''
        }
      </div>
      <p class="ajaxcart__shipping-text">${theme.strings.cart_shipping_at_checkout}</p>
      <button type="submit" class="button button--full" name="checkout">
        ${theme.strings.cart_checkout}
      </button>
    </div>
  `;
}
